export default __webpack_public_path__ + "static/media/chart-simple-solid.f68d2ef0.svg";